import { Box } from "@material-ui/core"
import { getGroupPurchaseGetGroupPurchaseSettings } from "api"
import { useIsDesktop } from "common/MediaQueries"
import BackButton from "components/BackButton/BackButton"
import { useGroupPurchasesContext } from "components/PurchasePage/GroupPurchasesContext"
import Image from "next/image"
import { useEffect, useState } from "react"
import styled from "styled-components"

const StyledImageWrapper = styled(Box)<{ $hasImg?: boolean }>`
  position: relative;
  top: 0;
  ${(p) => p.theme.breakpoints.down("sm")} {
    ${(p) => p?.$hasImg && "height: 250px;"}
    top: 0px;
  }
`

const StyledBackButton = styled(BackButton)`
  padding: 14px 16px 16px 16px;
  position: relative;
  z-index: 999;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 48px;
  }
`

const GroupPurchasesPageCover = ({
  backBtnOnClick,
}: {
  backBtnOnClick?: () => void
}) => {
  const isDesktop = useIsDesktop()
  const { prevPath } = useGroupPurchasesContext()

  const [coverImg, setCoverImg] = useState({
    imageUrl: "",
    alt: "",
  })
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getGroupPurchaseGetGroupPurchaseSettings()
        setCoverImg(response?.data?.body?.image)
      } catch (error) {
        console.error(error)
      }
    }
    fetchData()
  }, [])

  return (
    <StyledImageWrapper $hasImg={!!coverImg?.imageUrl}>
      {!isDesktop && (
        <StyledBackButton
          linkText="חזרה"
          prevPath={prevPath}
          hideTextOnMobile={true}
          beforeNavigation={() => {
            backBtnOnClick && backBtnOnClick()
          }}
        />
      )}
      {coverImg.imageUrl && (
        <Image
          src={coverImg.imageUrl}
          alt={coverImg.alt}
          layout={!isDesktop ? "fill" : "fixed"}
          width={isDesktop && "404x"}
          height={isDesktop && "267px"}
          style={{
            borderRadius: isDesktop ? "22px" : "0px",
          }}
        />
      )}
    </StyledImageWrapper>
  )
}
export default GroupPurchasesPageCover
